import * as ReactIntl from 'react-intl';

export const FormattedMessage = ReactIntl.FormattedMessage;
